"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useOverflowVisibility", {
    enumerable: true,
    get: function() {
        return useOverflowVisibility;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _overflowContext = require("./overflowContext");
function useOverflowVisibility() {
    const itemVisibility = (0, _overflowContext.useOverflowContext)((ctx)=>ctx.itemVisibility);
    const groupVisibility = (0, _overflowContext.useOverflowContext)((ctx)=>ctx.groupVisibility);
    return _react.useMemo(()=>({
            itemVisibility,
            groupVisibility
        }), [
        itemVisibility,
        groupVisibility
    ]);
}
